import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useWeek } from '@/contexts/WeekContext';
import { MenuComposer } from '@/components/menu/MenuComposer';
import { WeekNavigator } from '@/components/availability/WeekNavigator';
import { formatDateFull } from '@/lib/utils/date';
import { requireOrganizer } from '@/lib/auth/routeGuards';

export const Route = createFileRoute('/menu/compose')({
  beforeLoad: requireOrganizer,
  component: MenuComposeComponent,
});

function MenuComposeComponent() {
  const { t } = useTranslation();
  const { user } = Route.useRouteContext();
  const { weekStart, goToPreviousWeek, goToNextWeek, goToToday } = useWeek();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">
            {t('compose.title')}
          </h1>
          <p className="mt-2 text-gray-600">{t('compose.description')}</p>
          <p className="text-xs text-gray-500 mt-1">
            {t('menu.weekOf', { date: formatDateFull(weekStart) })}
          </p>
        </div>

        {/* Week navigator */}
        <WeekNavigator
          currentWeekStart={weekStart}
          onPreviousWeek={goToPreviousWeek}
          onNextWeek={goToNextWeek}
          onToday={goToToday}
        />

        {/* Composer */}
        <MenuComposer weekStart={weekStart} organizerId={user.id} />
      </div>
    </div>
  );
}
